import Cenarios from "@/repositories/Cenarios";
import cenario from "../../views/cenario/cenario";

// state
const state = () => ({
  cenarios: [],
  invertCenarios: [],
  invertCenariosConfirmed: [],
  cenario: null,
  listCenarios: [],
  filtros: {},
  arrowScroll: false,
  blExibeArrows: true,
  qtdeCenarios: 0,
  loadTemporaryCenarios: false,
  deleteCenario: [],
  formulariosValidos: 0,
  idFormularioErro: null,
  regra: [],
  cenariosPreenchidos: []
});

// getters
const getters = {
  getCenarios: state => {
    return state.cenarios;
  },
  getCenario: state => {
    return state.cenario;
  },
  getListCenario: state => {
    return state.listCenarios;
  },
  getFiltros: state => {
    return state.filtros;
  },
  getArrowScroll: state => {
    return state.arrowScroll;
  },
  getQtdeCenarios: state => {
    return state.cenarios.length;
  },
  getQtdeCenariosSelecionados: state => {
    return state.qtdeCenarios;
  },
  getInvertCenarios: state => {
    return state.invertCenarios;
  },
  getInvertCenariosConfirmed: state => {
    return state.invertCenariosConfirmed;
  },
  getDeleteCenario: state => {
    return state.deleteCenario;
  },
  getFormulariosValidos: state => {
    return state.formulariosValidos;
  },
  getIdFormularioErro: state => {
    return state.idFormularioErro;
  },
  getExibeArrows: state => {
    return state.blExibeArrows;
  },
  getRegra: state => {
    return state.regra;
  },
  getCenariosPreenchidos: state => {
    return state.cenariosPreenchidos;
  }
};

// mutations
const mutations = {
  SET_CENARIOS(state, cenarios) {
    state.cenarios = cenarios;
  },
  SET_CENARIO(state, cenario) {
    state.cenario = cenario;
  },
  SET_LIST_CENARIOS(state, listCenarios) {
    state.listCenarios = listCenarios;
    // console.log('listCenarios', state.listCenarios);
  },
  SET_FILTROS(state, filtros) {
    state.filtros = filtros;
  },
  SET_ARROW_SCROLL(state, arrowScroll) {
    state.arrowScroll = arrowScroll;
  },
  SET_INVERT_CENARIOS(state, invertCenarios) {
    // console.log('invertCenarios', invertCenarios);
    // console.log('0', invertCenarios[0]);
    // console.log('1', invertCenarios[1]);
    state.invertCenarios = invertCenarios;
    // console.log('invertCenarios', state.invertCenarios);
  },
  SET_INVERT_CENARIOS_CONFIRMED(state, invertCenariosConfirmed) {
    state.invertCenariosConfirmed = invertCenariosConfirmed;
  },
  SET_QTDE_CENARIOS(state, qtde) {
    state.qtdeCenarios = qtde;
  },
  SET_LOAD_TEMPORARY_CENARIOS(state, loadTemporaryCenarios) {
    state.loadTemporaryCenarios = loadTemporaryCenarios;
  },
  SET_DELETE_CENARIO(state, deleteCenario) {
    state.deleteCenario = deleteCenario;
  },
  SET_FORMULARIOS_VALIDOS(state, formulariosValidos) {
    state.formulariosValidos = formulariosValidos;
  },
  SET_ID_FORMULARIO_ERRO(state, id) {
    state.idFormularioErro = id;
  },
  SET_EXIBE_ARROWS(state, blExibeArrows) {
    state.blExibeArrows = blExibeArrows;
  },
  SET_REGRA(state, regra) {
    state.regra = regra;
  },
  SET_CENARIOS_PREENCHIDOS(state, cenariosPreenchidos) {
    state.cenariosPreenchidos = cenariosPreenchidos;
  }
};

// actions
const actions = {
  setRegra({ commit, state }, { id, regra }) {
    let regraOriginal = state.regra;

    let found = regraOriginal.find(r => r.id == id);

    if (!found) {
      regraOriginal.push({ id, regra });
    } else if (found) {
      regraOriginal.map(r => {
        if (r.id == id) {
          r.regra = regra;
        }
      });
    }

    commit("SET_REGRA", regraOriginal);
  },
  async fetchCenarios(context) {
    const usuario = context.rootGetters["login/getUser"];
    let cenarios = await Cenarios.getCenarios(usuario.id_usuario);

    if (!cenarios) {
      return;
    }

    context.commit("SET_CENARIOS", cenarios);
  },
  selectCenario({ commit }, cenario) {
    commit("SET_CENARIO", cenario);
  },
  setFiltros({ commit }, filtros) {
    commit("SET_FILTROS", filtros);
  },
  async deleteCenario({ commit, state }, id) {
    let cenarios = state.cenarios;

    await Cenarios.deleteCenario(id);

    cenarios = cenarios.filter(c => c.id != id);

    commit("SET_CENARIOS", cenarios);
  },
  setArrowScroll({ commit }, arrowScroll) {
    commit("SET_ARROW_SCROLL", arrowScroll);
  },
  setExibeArrows({ commit }, exibeArrows) {
    commit("SET_EXIBE_ARROWS", exibeArrows);
  },
  resetInvertCenarios({ commit }) {
    commit("SET_INVERT_CENARIOS", []);
    commit("SET_INVERT_CENARIOS_CONFIRMED", []);
  },
  setInvertCenariosConfirm({ commit }, invertCenarios) {
    // console.log('setInvertCenariosConfirm');

    commit("SET_INVERT_CENARIOS", invertCenarios);
  },
  setInvertCenariosConfirmed({ commit, state }, invertCenariosConfirmed) {
    // --
    const listCenarios = state.listCenarios;

    let cenarios = invertCenariosConfirmed.sort((a, b) => a.order - b.order);

    cenarios = cenarios.map((i, index) => {
      return { ...i, idCenario: listCenarios[index] };
    });

    invertCenariosConfirmed = cenarios.filter(i => {
      return i.idCenario == undefined ? false : true;
    });
    // --

    commit("SET_INVERT_CENARIOS_CONFIRMED", invertCenariosConfirmed);
  },
  setInvertCenarios({ commit, state }, invertCenarios) {
    if (state.loadTemporaryCenarios) {
      return;
    }
    if (!invertCenarios.idCenario && invertCenarios.idCenario != 0) {
      return;
    }

    let found = false;

    let cenarios = state.invertCenarios.map((f, index) => {
      if (f.idCenario == invertCenarios.idCenario) {
        found = true;
        return { ...invertCenarios, order: f.idCenario, found: true };
      }

      return f;
    });

    if (!found) {
      cenarios.push({ ...invertCenarios, order: invertCenarios.idCenario });
    }

    // cenarios = cenarios.filter(
    //   f => f.nomeCenario && f.nomeCenario != "" && f.ncm && f.ncm != ""
    // )

    const encontrou = cenarios.find(c => c == invertCenarios);
    if (encontrou) {
      return;
    }

    // --
    const listCenarios = state.listCenarios;

    cenarios = cenarios.sort((a, b) => a.order - b.order);
    cenarios = cenarios.map((i, index) => {
      return { ...i, idCenario: listCenarios[index] };
    });
    cenarios = cenarios.filter(i => {
      return i.idCenario == undefined ? false : true;
    });
    // --
    commit("SET_QTDE_CENARIOS", cenarios.length);
    commit("SET_INVERT_CENARIOS", cenarios);
  },
  setLoadTemporaryCenarios({ commit }, loadTemporaryCenarios) {
    commit("SET_LOAD_TEMPORARY_CENARIOS", loadTemporaryCenarios);
  },
  findTemporaryCenario({ commit, state }, id) {
    let cenario = state.invertCenarios.find(f => f.order == id);
    return cenario;
  },
  removeTemporaryCenario({ commit, state }, idCenario) {
    const order = state.deleteCenario;

    if (!order) {
      return;
    }

    let cenarios = state.invertCenarios.filter(f => f.idCenario != idCenario);

    commit("SET_QTDE_CENARIOS", cenarios.length);
    commit("SET_INVERT_CENARIOS", cenarios);
    commit("SET_INVERT_CENARIOS_CONFIRMED", cenarios);
  },
  resetListCenarios({ commit }) {
    let listCenarios = [];

    listCenarios.push(0);
    commit("SET_DELETE_CENARIO", []);
    commit("SET_LIST_CENARIOS", listCenarios);
  },
  addListCenarios({ commit, state }, idCenario) {
    if (!idCenario || idCenario == null) {
      return;
    }
    let listCenarios = state.listCenarios;

    const found = listCenarios.find(l => l == idCenario);
    if (found) {
      return;
    }

    listCenarios.push(idCenario);

    commit("SET_LIST_CENARIOS", listCenarios);
  },
  setDeleteCenario({ commit, state }, { id }) {
    // const listCenarios = state.listCenarios.filter(l => l != idCenario)
    const listCenarios = state.listCenarios;
    const updateDeleteCenario = state.deleteCenario;
    updateDeleteCenario.push(id);
    listCenarios.pop();
    // const invert = state.invertCenarios.filter(f => f.idCenario != id)
    // console.log('invert', invert);
    commit("SET_LIST_CENARIOS", listCenarios);
    commit("SET_INVERT_CENARIOS", []);
    commit("SET_DELETE_CENARIO", updateDeleteCenario);
  },
  deleteCenarioFalse({ commit, state }) {
    let found = false;
    const cenarios = state.invertCenarios.filter(i => {
      found = i.idCenario && i.idCenario != 0;
      return i.idCenario && i.idCenario != 0;
    });

    if (!found) {
      return;
    }

    commit("SET_INVERT_CENARIOS", cenarios);
    commit("SET_INVERT_CENARIOS_CONFIRMED", cenarios);
  },
  setFormulariosValidos({ commit, state }, increment) {
    let total = state.formulariosValidos + increment;

    if (increment == 0) {
      total = 0;
    }

    commit("SET_FORMULARIOS_VALIDOS", total);
  },
  setIdFormularioErro({ commit, state }, id) {
    commit("SET_ID_FORMULARIO_ERRO", id);
  },
  resetCenariosPreenchidos({ commit }) {
    commit("SET_CENARIOS_PREENCHIDOS", []);
  },
  setCenariosPreenchidos({ commit, state }, cenario) {
    if (!cenario) {
      return;
    }

    let cenarios = state.cenariosPreenchidos;

    if (cenarios.length == 0) {
      cenarios.push(cenario);
    }

    let found = cenarios.find(c => (c.id = cenario.id));

    if (!found) {
      cenarios.push(cenario);
    }

    cenarios = cenarios.map(c => {
      if ((c.id = cenario.id)) {
        c = cenario;
      }

      return c;
    });

    commit("SET_CENARIOS_PREENCHIDOS", cenarios);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
